import * as _4 from 'lodash4';
import { MajorProgram } from '../builders/major_programs_builder';

export class MajorBuilderServant {
  constructor(private numberFormatterFn: any, private HiringTrendEnum: any) {}

  public buildMajor(major: MajorProgram): MajorProgram {
    _4.merge(major, this.getFormattedMajorData(major));
    this.assignHiringTrendStatus(major);
    this.assignDevReqArray(major);
    return major;
  }

  private getFormattedMajorData(major: MajorProgram) {
    return {
      salary_trend_min_raw: major.salary_trend_min,
      salary_trend_max_raw: major.salary_trend_max,
      _salary_trend_min_sort: major.salary_trend_min || 0,
      _has_salary_information: !!major.salary_trend_min && !!major.salary_trend_max,
      _has_bachelor_salary_information: !!major.bachelor_salary_trend_min && !!major.bachelor_salary_trend_max,
      _has_masters_salary_information: !!major.masters_salary_trend_min && !!major.masters_salary_trend_max,
      salary_trend_min: this.numberFormatterFn.convertToThousandsOfDollars(major.salary_trend_min),
      salary_trend_max: this.numberFormatterFn.convertToThousandsOfDollars(major.salary_trend_max),
      salary_trend_average: this.numberFormatterFn.convertToThousandsOfDollars(major.salary_trend_average),
      estimated_tuition: this.numberFormatterFn.convertToThousandsOfDollars(major.estimated_tuition),
      bachelor_salary_trend_min: this.numberFormatterFn.convertToThousandsOfDollars(major.bachelor_salary_trend_min),
      bachelor_salary_trend_max: this.numberFormatterFn.convertToThousandsOfDollars(major.bachelor_salary_trend_max),
      masters_salary_trend_min: this.numberFormatterFn.convertToThousandsOfDollars(major.masters_salary_trend_min),
      masters_salary_trend_max: this.numberFormatterFn.convertToThousandsOfDollars(major.masters_salary_trend_max),
      credits: this.numberFormatterFn.formatNumber(major.credits),
      _interests: []
    };
  }

  assignHiringTrendStatus(major: MajorProgram) {
    major.hiringTrend = this.HiringTrendEnum.get(major.hiring_demand);
    major.hiring_demand = _4.get(major.hiringTrend, 'value.message', '');
    major._hiring_demand_ranking = _4.get(major.hiringTrend, 'ordinal', 0);
  }

  assignDevReqArray(major: MajorProgram) {
    major._has_dev_req = major.min_dev_course > 0;
    major._has_no_dev_req = !major._has_dev_req;
    major._dev_req_array = new Array(major.min_dev_course);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/servants/major_builder_servant.ts